import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pc/wood.module').then((m) => m.WoodModule),
  },

  {
    path: 'common',
    loadChildren: () =>
      import('./common/common.module').then((m) => m.CommonComponentModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
